export default function useUserData() {
  // Read on every render — never memoize. A useMemo([]) here froze the role at
  // mount time: <App> mounts before login writes "userdata", so it kept the
  // "user" default for the whole session while <Sidebar> (mounted after login)
  // read the real role. Admin links showed, the page rendered <FourOOne /> 401.
  const userData = window.localStorage.getItem("userdata");
  const parsed = userData ? JSON.parse(userData) : null;
  if (!parsed) {
    return {
      id: null,
      name: "User",
      email: "user@user.com",
      initials: "U",
      nickname: "User",
      color: "#4CAF50",
      role: "user",
      active: true,
      group: null,
    };
  }
  return {
    ...parsed,
    id: parsed.id ?? null,
    role: parsed.role ?? "user",
    active: parsed.active ?? true,
    group: parsed.group ?? null,
  };
}
